import { AbstractControl } from '@angular/forms';

export function hasDigit(control: AbstractControl) {
  const value = control.value;

  if (!value) {
    return null;
  }

  return /\d+/.test(value) ? null : { hasDigit: true };
}

export function hasLowerCase(control: AbstractControl) {
  const value = control.value;

  if (!value) {
    return null;
  }

  return /[a-z]+/.test(value) ? null : { hasLowerCase: true };
}

export function hasUpperCase(control: AbstractControl) {
  const value = control.value;

  if (!value) {
    return null;
  }

  return /[A-Z]+/.test(value) ? null : { hasUpperCase: true };
}

export function hasNonAlphaNumeric(control: AbstractControl) {
  const value = control.value;

  if (!value) {
    return null;
  }

  return /\W+/.test(value) ? null : { hasNonAlphaNumeric: true };
}
